// --- Storage helpers ---
export function getStoredUserInfo() {
  try {
    const raw = localStorage.getItem("userinfo");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

// --- Avatar helpers ---
export function stringToColor(string) {
  let hash = 0;

  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

export function getInitials(name) {
  if (!name || typeof name !== "string") return "?";

  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0][0].toUpperCase();

  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export function getAvatarProps(name) {
  return {
    sx: {
      bgcolor: stringToColor(name || "Unknown User"),
    },
    children: getInitials(name),
  };
}

// --- Identity resolver ---
export function getPresenceIdentity() {
  // 1. Logged-in Appwrite user
  const loggedInUser = getStoredUserInfo();

  if (loggedInUser) {
    const fullName =
      loggedInUser.name ||
      loggedInUser.email ||
      loggedInUser.$id ||
      "";

    if (fullName) {
      return {
        name: fullName,
        shortName: String(fullName).split("@")[0],
        email: loggedInUser.email || "",
        avatarProps: getAvatarProps(fullName),
        isLoggedIn: true,
      };
    }
  }

  // 2. Legacy/local fallback
  const explicit =
    localStorage.getItem("displayName") ||
    localStorage.getItem("name") ||
    localStorage.getItem("username") ||
    localStorage.getItem("email");

  if (explicit) {
    const fallbackName = String(explicit);

    return {
      name: fallbackName,
      shortName: fallbackName.split("@")[0],
      email: localStorage.getItem("email") || "",
      avatarProps: getAvatarProps(fallbackName),
      isLoggedIn: false,
    };
  }

  // 3. Anonymous fallback
  const fallbackId =
    sessionStorage.getItem("router_presence_client_id")?.slice(-4) ||
    Math.random().toString(36).slice(2, 6);

  const fallbackName = `User ${fallbackId}`;

  return {
    name: fallbackName,
    shortName: fallbackName,
    email: "",
    avatarProps: getAvatarProps(fallbackName),
    isLoggedIn: false,
  };
}